import { useEffect, useState } from 'react';
import { ActionCentreDataInputModel, SwiftFoxActionCentreResult } from './contracts';

export const createActionCentrePDF = async (
	input: ActionCentreDataInputModel,
	requestToken: string
): Promise<{ pdfString?: string; error?: string }> => {
	const res = await fetch('/Umbraco/Api/Membership/ActionCentrePdf', {
		method: 'POST',
		body: JSON.stringify(input),
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			RequestVerificationToken: requestToken
		}
	});
	if (res.ok) {
		const response = await res.json();
		if (response.success === true) {
			return { pdfString: response.result };
		} else {
			const err = response.message;
			return { error: err };
		}
	} else {
		const err = await res.text();
		return { error: err };
	}
};

export const fetchActionCentreData = async (
	input: ActionCentreDataInputModel,
	requestToken: string
): Promise<{ result?: SwiftFoxActionCentreResult; error?: string }> => {
	const res = await fetch('/Umbraco/Api/Membership/ActionCentreData', {
		method: 'POST',
		body: JSON.stringify(input),
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			RequestVerificationToken: requestToken
		}
	});
	if (res.ok) {
		const response = await res.json();
		if (response.success === true) {
			return { result: response.result };
		} else {
			const err = response.message;
			return { error: err };
		}
	} else {
		const err = await res.text();
		return { error: err };
	}
};
export const useActionCentre = (input: ActionCentreDataInputModel, requestToken: string) => {
	const [error, setError] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<SwiftFoxActionCentreResult | undefined>(undefined);

	useEffect(() => {
		async function fetchData() {
			try {
				setLoading(true);
				setError('');
				const res = await fetchActionCentreData(input, requestToken);
				if (res.error) {
					setError(res.error);
				} else {
					setData(res.result);
				}
				setLoading(false);
			} catch (e) {
				setLoading(false);
				setError(`Error: ${e.message}`);
			}
		}
		fetchData();
		return () => {
			setError('');
			setLoading(false);
			setData(undefined);
		};
	}, [input['sort'], input['filters'], input['page'], input['sourceFilter']]);

	return { error, loading, data };
};
